module.exports = __webpack_public_path__ + "img/hero.f730f136.jpg";